export default __webpack_public_path__ + "static/media/course3_W.d7b2d59d.gif";